import { useRoute, useRouter } from 'vue-router';

import { pageFromRouteQuery, updateQuery as routerUpdateQuery } from '@/shared/services/router';

export default function useRouterHelper() {
  const route = useRoute();
  const router = useRouter();

  function getFiltersFromQuery({ paged }) {
    const newFilters = { ...route.query };
    if (paged) {
      newFilters.page = pageFromRouteQuery(route.query.page);
    }
    return newFilters;
  }

  async function updateQuery(newQuery) {
    await routerUpdateQuery(router, route, newQuery);
  }

  return {
    getFiltersFromQuery,
    updateQuery,
  };
}
